var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.hideMobile),expression:"hideMobile"}],staticClass:"sidebar"},[_vm._t("default",[_vm._v("Sidebar")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }